import { render, staticRenderFns } from "./mods-icon.vue?vue&type=template&id=0e915cde"
import script from "./mods-icon.vue?vue&type=script&lang=js"
export * from "./mods-icon.vue?vue&type=script&lang=js"
import style0 from "./mods-icon.vue?vue&type=style&index=0&id=0e915cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports